import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import styles from "./Question.module.scss";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
export default function Question({ prompt, initialOpen, children, }) {
    const [open, setOpen] = useState(initialOpen);
    return (_jsxs("div", { className: styles.question, children: [_jsxs("div", { className: styles.prompt, onClick: () => setOpen(!open), children: [_jsx("h2", { children: prompt }), open ? _jsx(FaChevronUp, {}) : _jsx(FaChevronDown, {})] }), open && _jsx("p", { children: children })] }));
}
